/* eslint-disable no-redeclare */
export function checkNotAllowedProps(props, notAllowedArgs, componentName) {
    if (!props || !notAllowedArgs || notAllowedArgs.length === 0) {
        return;
    }
    const notAllowedProps = [];
    const propKeys = Object.keys(props);
    for (let i = 0; i < notAllowedArgs.length; i += 1) {
        const key = notAllowedArgs[i];
        if (propKeys.includes(key)) {
            notAllowedProps.push(key);
        }
    }
    if (notAllowedProps.length > 0) {
        console.warn(`"${notAllowedProps.join(',')}" ${notAllowedProps.length > 1 ? 'are' : 'is'} not allowed in ${componentName}. If you pass these parameters to the component, they will not take effect.`);
    }
}
export function extractProps(props, propNames) {
    const filter = typeof propNames === 'function'
        ? propNames
        : (k) => propNames.includes(k);
    const result = {};
    const rest = {};
    Object.keys(props).forEach((key) => {
        if (filter(key)) {
            result[key] = props[key];
        }
        else {
            rest[key] = props[key];
        }
    });
    return [result, rest];
}
/**
 * Extract role, tabIndex and aria-* props to a new object.
 * @param props The original props to extract.
 * @returns A tuple, with extracted aria props as the first element, and rest props as the second element.
 */
export function extractAriaProps(props) {
    return extractProps(props, (key) => key === 'role' ||
        key === 'tabIndex' ||
        key.startsWith('aria-'));
}
